import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('customer'), ...new Mutations('customers'), ...new Mutations('activeCustomer'), ...new Mutations('cache'),
};
